import React from "react";
import TotalStores from "../../shared/assets/icons/TotalStores.jsx";
import TotalJobs from "../../shared/assets/icons/TotalJobs.jsx";
import OnHoldJobs from "../../shared/assets/icons/OnHoldJobs.jsx";
import ApproveIconWithoutBorder from "../../shared/assets/icons/ApproveIconWithoutBorder.jsx";
import RejectWithoutBorder from "../../shared/assets/icons/RejectWithoutBorder.jsx";
import HoldOnWithoutBorder from "../../shared/assets/icons/HoldOnWithoutBorder.jsx";
import PendingIcon from "../../shared/assets/icons/PendingIcon.jsx";

const ClientStatCards = ({ counts }) => {
  const cards = [
    {
      title: "Total Stores",
      value: counts.stores,
      icon: <TotalStores />,
      bg: "bg-green-100",
      iconColor: "text-green-600",
    },
    {
      title: "Total Jobs",
      value: counts.total,
      icon: <TotalJobs />,
      bg: "bg-cyan-100",
      iconColor: "text-cyan-600",
    },
    {
      title: "Approved Jobs",
      value: counts.approved,
      icon: <ApproveIconWithoutBorder width={35} height={35} />,
      bg: "bg-green-100",
      iconColor: "text-green-600",
    },
    {
      title: "Rejected Jobs",
      value: counts.rejected,
      icon: <RejectWithoutBorder width={35} height={35} />,
      bg: "bg-red-100",
      iconColor: "text-red-600",
    },
    {
      title: "On Hold Jobs",
      value: counts.holdOn,
      icon: <HoldOnWithoutBorder width={35} height={35} />,
      bg: "bg-yellow-100",
      iconColor: "text-yellow-600",
    },
    {
      title: "Pending Jobs",
      value: counts.pending,
      icon: <PendingIcon width={35} height={35} />,
      bg: "bg-purple-100",
      iconColor: "text-purple-600",
    },
  ];
  return (
    <div className="grid md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4 ">
      {cards.map((card, i) => (
        <div
          key={i}
          className="h-[80px] bg-white rounded-xl border flex items-center px-5 gap-8"
        >
          <div
            className={`w-12 h-12 flex items-center justify-center rounded-lg ${card.bg} ${card.iconColor}`}
          >
            {card.icon}
          </div>

          <div>
            <p className="text-gray-500 text-sm">{card.title}</p>
            <p className="text-2xl text-black font-semibold">{card.value}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ClientStatCards;
